import { render, staticRenderFns } from "./CrmPullToRefreshHost.vue?vue&type=template&id=a2bbf1e6&"
import script from "./CrmPullToRefreshHost.vue?vue&type=script&lang=ts&"
export * from "./CrmPullToRefreshHost.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports